import * as z from "zod";
import {
  MerchantDashboardSummarySchema,
  MerchantDashboardWidgetSchema,
} from "./merchant-dashboard-fields";

export const getOrCreateDefaultMerchantDashboard = {
  name: "getOrCreateDefaultMerchantDashboard" as const,
  input: z.object({}),
  output: z.object({
    dashboard: MerchantDashboardSummarySchema,
    widgets: z.array(MerchantDashboardWidgetSchema),
  }),
};
